// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__3hnbW","wrapper":"Badge_wrapper__Ie716"};